<ng-container
  *ngTemplateOutlet="filterList; context: {childFilters: allFilters, joinString: initialJoinString, level: 0}"></ng-container>

<ng-template #filterList let-childFilters="childFilters" let-joinString="joinString" let-level="level">
  <ng-container *ngFor="let filter of childFilters; let i = index">
    <div class="search-breadcrumb" [class.active]="isFilterActive(filter)" *ngIf="isFilterCriterium(filter)">
      <mat-icon *ngIf="filter?.icon">{{ filter.icon }}</mat-icon>
      <app-search-menu [entries]="queryFilters.bind(this)"
        (entrySelected)="updateFilter(level === 0 ? filters : childFilters, filter, $event)">
        <span class="menu-trigger filter-name" tabindex="0" [matTooltip]="getLabelForFilter(filter) | translate">{{
          getLabelForFilter(filter) | translate
          }}</span>
      </app-search-menu>
      <button class="operator" [matMenuTriggerFor]="operatorMenu">{{ operatorSignFor(filter) }}</button>
      <ng-container
        *ngTemplateOutlet="filterValueInput; context: {filter: filter, availableFilter: availableFilterFor(filter)}"></ng-container>
      <button mat-icon-button class="toggle-visibility" [class.active]="isFilterActive(filter)"
        (click)="$event.stopPropagation(); toggleFilterActivationStatus(filter)"
        [matTooltip]="(isFilterActive(filter) ? 'aria.label.deactivateFilter' : 'aria.label.activateFilter') | translate"
        *ngIf="level === 0">
        <mat-icon>{{ isFilterActive(filter) ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
      <button mat-icon-button class="toggle-visibility"
        (click)="removeFilter(level === 0 ? filters : childFilters, filter)">
        <mat-icon>close</mat-icon>
      </button>
      <mat-menu #operatorMenu>
        <button mat-menu-item *ngFor="let operator of getPossibleOperations(availableFilterFor(filter))"
          [class.active]="operator === filter.operator" (click)="changeOperator(filter, operator)">
          {{ ('common.label.operators.' + operator) | translate }}
        </button>
      </mat-menu>
    </div>
    <div class="boolean-container" *ngIf="!isFilterCriterium(filter)">
      <ng-container
        *ngTemplateOutlet="filterList; context: {childFilters: filter.filters, joinString: ('common.label.' + filter.operator), level: level + 1}"></ng-container>
    </div>
    <span *ngIf="joinString?.length && i < childFilters.length - 1" class="join-string">
      {{ joinString | translate}}
    </span>
  </ng-container>
  <app-search-menu [entries]="queryFilters.bind(this)"
    (entrySelected)="addFilter(level === 0 ? filters : childFilters, $event)" *ngIf="availableFilters">
    <button class="add-filter-button" mat-button>
      <ng-container *ngIf="!joinString?.length">
        <mat-icon>add</mat-icon>
        <span>{{ 'common.button.addSearchFilter' | translate }}</span>
      </ng-container>
      <span>{{ joinString | translate }}</span>
    </button>
  </app-search-menu>
</ng-template>

<ng-template #filterValueInput let-filter="filter" let-availableFilter="availableFilter">
  <input class="filter-value" type="string" [(ngModel)]="filter.value" (change)="emitFilterChange()"
    *ngIf="availableFilter?.type === 'string'" [style.width]="(filter.value.length + 1) + 'ch'"
    [class.empty]="!filter.value.length" [matTooltip]="filter.value">
  <input class="filter-value" type="number" [(ngModel)]="filter.value" (change)="emitFilterChange()"
    *ngIf="availableFilter?.type === 'number' && !isBetweenOperator(filter.operator)" [matTooltip]="filter.value">
  <ng-container *ngIf="availableFilter?.type === 'number' && isBetweenOperator(filter.operator)">
    <input class="filter-value" type="number" [(ngModel)]="ensureBetweenValue(filter).from"
      (change)="emitFilterChange()" [matTooltip]="filter.value.from">
    <span class="between-separator">–</span>
    <input class="filter-value" type="number" [(ngModel)]="ensureBetweenValue(filter).to"
      (change)="emitFilterChange()" [matTooltip]="filter.value.to">
  </ng-container>
  <mat-checkbox class="filter-value" *ngIf="availableFilter?.type === 'boolean'" (change)="emitFilterChange()"
    [(ngModel)]="filter.value">
  </mat-checkbox>
  <span class="filter-value" *ngIf="availableFilter?.type === 'date' && !isBetweenOperator(filter.operator)"
    [dueAtSelector]="true" (dueAtChanged)="dueAtChanged(filter, $event)" [useTime]="filterUseTime(filter)"
    (useTimeChange)="filterUseTimeChanged(filter, $event)" (close)="emitFilterChange()"
    [initialDate]="filter.value" [allowEndTime]="false">
    {{ filter.value | date: dateFormatForFilter(filter) }}
  </span>
  <ng-container *ngIf="availableFilter?.type === 'date' && isBetweenOperator(filter.operator)">
    <span class="filter-value between-bound" [class.empty]="!hasBetweenBound(filter.value.from)"
      [dueAtSelector]="true" (dueAtChanged)="betweenBoundChanged(filter, 'from', $event)"
      [useTime]="filterUseTime(filter)" (useTimeChange)="filterUseTimeChanged(filter, $event)"
      (close)="emitFilterChange()" [initialDate]="ensureBetweenValue(filter).from" [allowEndTime]="false">
      <ng-container *ngIf="hasBetweenBound(filter.value.from); else emptyFromBound">
        {{ filter.value.from | date: dateFormatForFilter(filter) }}
      </ng-container>
      <ng-template #emptyFromBound>…</ng-template>
    </span>
    <span class="between-separator">–</span>
    <span class="filter-value between-bound" [class.empty]="!hasBetweenBound(filter.value.to)"
      [dueAtSelector]="true" (dueAtChanged)="betweenBoundChanged(filter, 'to', $event)"
      [useTime]="filterUseTime(filter)" (useTimeChange)="filterUseTimeChanged(filter, $event)"
      (close)="emitFilterChange()"
      [initialDate]="ensureBetweenValue(filter).to ?? ensureBetweenValue(filter).from"
      [allowEndTime]="false">
      <ng-container *ngIf="hasBetweenBound(filter.value.to); else emptyToBound">
        {{ filter.value.to | date: dateFormatForFilter(filter) }}
      </ng-container>
      <ng-template #emptyToBound>…</ng-template>
    </span>
  </ng-container>
  <span class="filter-value"
    *ngIf="availableFilter?.type !== 'boolean' && availableFilter?.type !== 'string' && availableFilter?.type !== 'number' && availableFilter?.type !== 'date'">{{
    isBoolean(filter?.value)
    ? ((filter.value ? "common.label.yes" : "common.label.no")
    | translate)
    : filter.value
    }}
  </span>
</ng-template>